import CompanyApprovalDialogContainer from './company-approval-dialog.container';

export default CompanyApprovalDialogContainer;
